/**
import {t, Trans} from '@lingui/macro';
import {withI18n, useLingui} from "@lingui/react";
* if company return Attn: first_name last_name + billing address.
* if individual return just the billing address.
* @param {first_name, last_name, legal_name, billing_party,...} contact from list/contacts
* @param {String} address Optional. Default to contact's billing address if not specified.
*/
export const getBillingPartyString = (contact, address = null) => {
    let isIndividual;
    const addressString = address || contact.billing_party || '';
    if (contact.first_name && contact.last_name) {
        isIndividual = `${contact.first_name} ${contact.last_name}` === contact.legal_name;
        return !isIndividual ?
            `Attn: ${contact.first_name} ${contact.last_name}\n${addressString}` :
            addressString;
    }
    if (contact.first_name && !contact.last_name) {
        isIndividual = contact.first_name === contact.legal_name;
        return !isIndividual ?
            `Attn: ${contact.first_name}\n${addressString}` :
            addressString;
    }
    if (!contact.first_name && contact.last_name) {
        isIndividual = contact.last_name === contact.legal_name;
        return !isIndividual ?
            `Attn: ${contact.last_name}\n${addressString}` :
            addressString;
    }
    // is company
    return addressString;
};
